import { useNavigate } from 'react-router-dom'
import { Pin } from 'lucide-react'

export default function WelcomePage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center px-4 relative overflow-hidden">
      {/* Ambient background effects */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 via-purple-500/10 to-pink-500/10"></div>
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl"></div>
      
      <div className="max-w-3xl w-full text-center relative z-10">
        {/* Logo */}
        <div className="flex justify-center mb-12">
          <img 
            src="/iconextn.png" 
            alt="Memtrail Logo" 
            className="w-24 h-24 object-contain"
          />
        </div>

        {/* Main Message */}
        <div className="bg-slate-800/50 backdrop-blur-xl rounded-3xl p-12 shadow-2xl border border-slate-700/50">
          <h1 className="text-5xl font-bold mb-6">
            <span className="text-white">You're All Set! </span>
            <span className="text-4xl">🎉</span>
          </h1>
          
          <div className="space-y-5 text-lg mb-10">
            <p className="flex items-center justify-center gap-3 text-slate-300">
              <Pin className="w-5 h-5 text-blue-400" />
              <span>Pin the extension to your browser toolbar</span>
            </p>
            <p className="text-slate-300">Sign in to your account</p>
            <p className="text-xl font-semibold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
              Start saving content to your brain!
            </p>
          </div>

          <button
            onClick={() => navigate('/login')}
            className="bg-gradient-to-r from-blue-500 to-purple-600 text-white font-semibold px-12 py-4 rounded-full hover:from-blue-600 hover:to-purple-700 transition-all text-lg shadow-lg shadow-blue-500/25 hover:shadow-xl hover:shadow-blue-500/40 transform hover:scale-105"
          >
            Sign In Now
          </button>
        </div>

        {/* Subtle hint */}
        <p className="text-slate-400 text-sm mt-8">
          Look for the Memtrail icon in your browser's extension area
        </p>
      </div>
    </div>
  )
}